import { Theme } from '@mui/material/styles';

export const getLocationCardStyles = ({
	isCurrentSelectedFacility,
	isSmallScreen,
}: {
	isCurrentSelectedFacility?: boolean;
	isSmallScreen?: boolean;
}) => ({
	flexShrink: '0',
	width: 'auto',
	borderRadius: '0.5rem',
	border: isSmallScreen ? 'none' : '0.0625rem solid',
	borderTop: '0.0625rem solid',
	borderColor: isSmallScreen ? 'neutrals.primary' : 'primary.main',
	boxShadow: 'none',
	backgroundColor: isCurrentSelectedFacility ? 'secondary.light' : 'neutrals.white',
	minHeight: 'auto',
	height: 'fit-content',
	display: 'grid',
	p: '1rem',
	mx: '1.5rem',
	...(isSmallScreen && {
		borderRadius: '0',
		mx: '0',
		'&:first-of-type': {
			borderTop: 'none',
		},
	}),
});

export const cardActionStyles = {
	width: '100%',
	justifyContent: 'start',
	p: '0',
};

export const locationNameAndPhoneWrapperStyles = {
	display: 'flex',
	justifyContent: 'space-between',
	alignItems: 'center',
};

export const phoneLinkStyles = {
	padding: 0,
	backgroundColor: 'transparent',
	minHeight: 'unset',
	'&:hover': {
		backgroundColor: 'transparent',
		opacity: 0.8,
	},
};

export const getAddressLinkStyles = ({ isSmallScreen }: { isSmallScreen?: boolean }) => ({
	textDecoration: 'none',
	display: 'inline-flex',
	flexDirection: isSmallScreen ? 'row' : 'column',
	'&:hover': {
		opacity: 0.8,
	},
});

export const iconButtonStyles = {
	padding: 0,
	minWidth: '1.25rem',
	minHeight: 'unset',
	'&:hover': {
		backgroundColor: 'transparent',
		opacity: 0.8,
	},
	'&:focus': {
		backgroundColor: 'transparent',
	},
};

export const pinMarketStyles = {
	display: 'flex',
	flexDirection: 'column',
	alignItems: 'center',
	gap: '0.25rem',
};

export const servicesGroupListStyles = {
	display: 'grid',
	gridTemplateColumns: '50% 50%',
	justifyContent: 'start',
	gap: '0.5rem',
};

export const servicesGroupTitleStyles = (theme: Theme) => ({
	display: 'block',
	paddingY: '0.25rem',
	borderTop: `1px solid ${theme.palette.primary.light}`,
});

export const serviceToggleStyles = {
	display: 'flex',
	flexFlow: 'row no-wrap',
	justifyContent: 'space-between',
	paddingLeft: '0',
	paddingRight: '0',
};
